var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 114 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h114v57H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h114v17H9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#da121a",
    d: "M9 20h105v17H9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#078930",
    d: "M9 40h105v17H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#009edb",
    d: "M49.363 28.5 0 57V0z",
    style: {
      fill: "#45b4db",
      fillOpacity: 1
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "m22.772 37.093-5.584-17.186-5.584 17.185 14.619-10.62H8.153Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs);
export default __webpack_public_path__ + "static/media/ss.cc69923aac5e8db51f0f02d8fabd9f44.svg";
export { ForwardRef as ReactComponent };